import GuarantorProfilePage from '@/features/applications/[applicationId]/guarantors/[guarantorId]/profile/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authed/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile',
)({
  component: GuarantorProfilePage,
})
